export function TransferReference(transferStatus: {
  response: { reference: string };
}) {
  return (
    <span className="mobius-transfer-reference__span">
      {transferStatus.response.reference}
    </span>
  );
}
